import { Box, Dialog, IconButton, styled } from '@mui/material';
import { Edit } from '@styled-icons/boxicons-solid/Edit';
import { Close } from '@styled-icons/evaicons-solid/Close';
import { DialogTitle } from 'DesignSystem';
import React, { FC } from 'react';
import { IDefaultDialogProps } from 'types/dialog.types';
import EditDocumentContainer from './EditDocumentContainer';
import { IBaseDocument } from 'FeatureModules/Document/types/document.types';

export interface IEditDocumentDialogProps extends IDefaultDialogProps {
  document: IBaseDocument;
  onDelete: () => void;
  onUpdate?: () => void;
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  margin: 'auto',

  '& .MuiDialog-paper': {
    width: 600,
    maxWidth: '100%',
    overflow: 'visible',
    padding: theme.spacing(3, 4, 10),
  },
}));

const CloseButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 1,
}));

const EditDocumentDialog: FC<IEditDocumentDialogProps> = ({
  document,
  onClose,
  onDelete,
  onUpdate,
}) => {
  const handleDelete = () => {
    onDelete();
    onClose?.();
  };
  return (
    <StyledDialog open onClose={onClose}>
      <CloseButton onClick={onClose}>
        <Close size={23} />
      </CloseButton>
      <Box mb={2}>
        <DialogTitle icon={<Edit size={16} />}>Edit Document</DialogTitle>
      </Box>
      <EditDocumentContainer
        renderedOnDialog
        documentId={document?.id}
        onDelete={handleDelete}
        onClose={onClose}
        onUpdate={onUpdate}
      />
    </StyledDialog>
  );
};

export default EditDocumentDialog;
